{
  "page": {
    "title": "Barcha xodimlar"
  },
  "subtabs": {
    "label": "Xodimlar bo'limlari",
    "all": "Barcha xodimlar"
  },
  "actions": {
    "add": "Xodim qo'shish",
    "addAdmin": "Suv ombori admini qo'shish",
    "addMenu": "Qo'shish turini tanlash",
    "search": "Qidirish",
    "view": "Ko'rish",
    "edit": "Tahrirlash",
    "permissions": "Huquqlar",
    "block": "Bloklash",
    "unblock": "Blokdan chiqarish",
    "delete": "O'chirish",
    "rowMenu": "Amallar"
  },
  "table": {
    "label": "Xodimlar jadvali",
    "employee": "Xodim",
    "position": "Lavozim",
    "phone": "Telefon",
    "adminPanel": "Admin panel",
    "monitoringPanel": "Monitoring panel",
    "actions": "Harakat",
    "total": "Jami: {{count}} ta",
    "empty": "Xodimlar mavjud emas",
    "emptyHint": "Hali xodim qo'shilmagan. «Xodim qo'shish» tugmasini bosing.",
    "noResults": "Hech narsa topilmadi",
    "noResultsHint": "«{{q}}» bo'yicha xodim topilmadi.",
    "clear": "Tozalash",
    "loadError": "Ma'lumotlarni yuklab bo'lmadi",
    "retry": "Qayta urinish",
    "pagination": {
      "previous": "Oldingi sahifa",
      "next": "Keyingi sahifa"
    }
  },
  "status": {
    "active": "Faol",
    "inactive": "Nofaol",
    "blocked": "Bloklangan"
  },
  "access": {
    "admin": {
      "full": "To'liq (CRUD)",
      "some": "Kiradi",
      "none": "Kirmaydi"
    },
    "monitoring": {
      "full": "To'liq",
      "viewOnly": "Faqat ko'rish",
      "none": "Kirmaydi",
      "parts": {
        "view": "ko'rish",
        "edit": "tahrirlash",
        "delete": "o'chirish",
        "upload": "fayl"
      }
    }
  },
  "form": {
    "addTitle": "Xodim qo'shish",
    "addAdminTitle": "Suv ombori admini qo'shish",
    "steps": {
      "label": "Qadamlar",
      "general": "Umumiy ma'lumot",
      "permissions": "Huquqlar",
      "done": "bajarildi",
      "current": "joriy qadam"
    },
    "avatar": {
      "upload": "Rasm yuklash",
      "hint": "JPG yoki PNG, 2 MB gacha",
      "uploading": "Yuklanmoqda...",
      "remove": "Rasmni o'chirish",
      "invalid": "Faqat JPG yoki PNG, 2 MB gacha",
      "failed": "Rasmni yuklab bo'lmadi"
    },
    "fullName": "F.I.SH",
    "position": "Lavozim",
    "phone": "Telefon",
    "reservoir": "Suv ombori",
    "login": "Login",
    "password": "Parol",
    "role": "Rol",
    "fullNamePlaceholder": "Ism Familiya",
    "positionPlaceholder": "Masalan: Bosh muhandis",
    "phonePlaceholder": "+998 90 123 45 67",
    "loginPlaceholder": "ism.familiya",
    "passwordUnchanged": "••••••••••",
    "passwordHint": "Yangi parol saqlanganda xodimning barcha sessiyalari yopiladi.",
    "reservoirLocked": "Faqat tashkilot admini boshqa suv omborini tanlay oladi",
    "roles": {
      "tenant_member": "Xodim",
      "tenant_admin": "Suv ombori admini",
      "org_admin": "Tashkilot admini",
      "platform_admin": "Asosiy admin"
    },
    "active": "Faol xodim",
    "copy": "Nusxa olish",
    "copied": "Nusxalandi",
    "regenerateLogin": "Loginni qayta yaratish",
    "regeneratePassword": "Yangi parol yaratish",
    "showPassword": "Parolni ko'rsatish",
    "hidePassword": "Parolni yashirish",
    "loginTaken": "Bu login band. Bo'sh variant: {{suggestion}}",
    "useSuggestion": "{{suggestion}} ni olish",
    "continue": "Davom etish",
    "back": "Orqaga",
    "save": "Saqlash",
    "cancel": "Bekor qilish",
    "backLink": "Ortga qaytish",
    "employeeCaption": "Xodim: {{name}}",
    "adminNote": "Suv ombori admini barcha bo'limlarga to'liq huquqqa ega — alohida huquqlar berilmaydi.",
    "selfNote": "O'zingizning holatingiz va rolingizni o'zgartira olmaysiz."
  },
  "validation": {
    "required": "Bo’sh maydonni to’ldiring",
    "min": "Kamida {{count}} ta belgi kiriting",
    "max": "Ko'pi bilan {{count}} ta belgi",
    "login": "Faqat lotin harflari, raqamlar va . _ -",
    "phone": "Telefon raqami noto'g'ri",
    "fixErrors": "Maydonlardagi xatolarni tuzating"
  },
  "toast": {
    "created": "Xodim qo'shildi",
    "createdElsewhere": "Xodim «{{tenant}}»ga qo'shildi",
    "saved": "Saqlandi",
    "noChanges": "O'zgartirish kiritilmagan",
    "passwordChanged": "Parol yangilandi",
    "moved": "Xodim «{{tenant}}»ga o'tkazildi",
    "blocked": "Xodim bloklandi",
    "unblocked": "Xodim blokdan chiqarildi",
    "deleted": "Xodim o'chirildi",
    "error": "Xatolik yuz berdi",
    "copied": "Nusxalandi",
    "copyFailed": "Nusxa olib bo'lmadi",
    "exported": "Loglar eksport qilindi",
    "nothingToExport": "Eksport uchun loglar yo'q"
  },
  "dirty": {
    "title": "O'zgarishlar saqlanmagan",
    "text": "Kiritilgan ma'lumotlar yo'qoladi.",
    "stay": "Qolish",
    "leave": "Chiqish"
  },
  "detail": {
    "label": "Xodim ma'lumotlari",
    "loading": "Yuklanmoqda...",
    "tabs": {
      "label": "Xodim bo'limlari",
      "logs": "Loglar",
      "info": "Ma'lumot",
      "permissions": "Huquqlar"
    },
    "danger": "Xavfli zona",
    "block": "Xodimni bloklash",
    "blockHint": "Bloklangan xodim tizimga kira olmaydi. Loglar saqlanadi.",
    "unblock": "Blokdan chiqarish",
    "blockedHint": "{{date}} da bloklangan",
    "blockedByHint": "{{date}} da bloklangan ({{name}})",
    "delete": "Xodimni o'chirish",
    "deleteHint": "Xodim suv omboridan o'chiriladi. Loglar saqlanadi.",
    "confirmBlock": {
      "title": "Xodimni bloklash",
      "text": "«{{name}}» tizimga kira olmaydi. Faol sessiyalar yopiladi.",
      "confirm": "Bloklash"
    },
    "confirmUnblock": {
      "title": "Blokdan chiqarish",
      "text": "«{{name}}» yana tizimga kira oladi.",
      "confirm": "Blokdan chiqarish"
    },
    "confirmDelete": {
      "title": "Xodimni o'chirish",
      "text": "«{{name}}» suv omboridan o'chiriladi. Loglar saqlanadi.",
      "confirm": "O'chirish"
    },
    "readOnly": "Ko'rish rejimi — o'zgartirish uchun huquqingiz yo'q.",
    "adminReadOnly": "Suv ombori adminini faqat adminlar o'zgartira oladi.",
    "notFound": "Xodim topilmadi",
    "notFoundHint": "Xodim o'chirilgan yoki boshqa suv omboriga o'tkazilgan bo'lishi mumkin."
  },
  "permissions": {
    "panels": {
      "admin": {
        "title": "Admin panel",
        "subtitle": "Boshqaruv paneli - CRUD huquqlari"
      },
      "monitoring": {
        "title": "Monitoring panel",
        "subtitle": "Monitoring - ko'rish va fayl yuklash"
      }
    },
    "searchModules": "Modul qidirish",
    "searchMenus": "Menyu qidirish",
    "selectAll": "Hammasini belgilash",
    "clearAll": "Hammasini olib tashlash",
    "clearSearch": "Tozalash",
    "moduleCount": "{{count}} ta modul",
    "menuCount": "{{count}} ta menyu",
    "results": "{{count}} ta natija",
    "moreModules": "Yana {{count}} ta modul - qidiruv orqali toping",
    "moreMenus": "Yana {{count}} ta menyu - qidiruv orqali toping",
    "noResults": "Hech narsa topilmadi",
    "notGrantable": "Sizda bu huquq yo'q",
    "expand": "{{panel}} — ochish",
    "collapse": "{{panel}} — yopish",
    "toggle": "{{panel}} — yoqish",
    "beyondCeiling": "Bu xodimda sizda yo'q huquqlar bor — ularni o'zgartira olmaysiz.",
    "modules": {
      "devices": "Qurilmalar",
      "device_categories": "Qurilma turkumlari",
      "device_config": "Qurilma konfiguratsiyasi",
      "employees": "Xodimlar",
      "connectors": "Konnektorlar",
      "device_locations": "Qurilma joylashgan o'rni",
      "device_info": "Qurilma haqida ma'lumot",
      "device_calibration": "Qurilma kolibrovkalash"
    },
    "menus": {
      "dashboard": "Bosh panel",
      "device_config": "Qurilma konfiguratsiyasi",
      "device_categories": "Qurilma turkumlari",
      "documents": "Hujjatlar",
      "reports": "Hisobotlar",
      "sections": "Bo'limlar",
      "charts": "Grafiklar"
    },
    "adminActions": {
      "create": "Yaratish",
      "read": "O'qish",
      "update": "Tahrirlash",
      "delete": "O'chirish"
    },
    "monitoringActions": {
      "view": "Ko'rinadi",
      "edit": "Tahrirlash",
      "delete": "O'chirish",
      "upload": "Fayl yuklash"
    }
  },
  "logs": {
    "search": "Loglardan qidirish",
    "filtersLabel": "Log turi",
    "filters": {
      "all": "Barchasi",
      "error": "Xatolar",
      "admin": "Admin panel",
      "monitoring": "Monitoring"
    },
    "range": "Davr",
    "ranges": {
      "today": "Bugun",
      "7d": "Oxirgi 7 kun",
      "30d": "Oxirgi 30 kun",
      "90d": "Oxirgi 90 kun",
      "all": "Barcha vaqt",
      "custom": "Maxsus oraliq"
    },
    "customFrom": "Dan",
    "customTo": "Gacha",
    "apply": "Qo'llash",
    "today": "BUGUN",
    "yesterday": "KECHA",
    "entries": "{{count}} ta yozuv",
    "error": "Xato",
    "export": "Loglarni eksport qilish",
    "loadMore": "Yana yuklash",
    "empty": "Loglar topilmadi",
    "emptyHint": "Tanlangan davrda yozuvlar yo'q.",
    "loadError": "Loglarni yuklab bo'lmadi",
    "showDetails": "Batafsil",
    "panels": {
      "admin": "Admin panel",
      "monitoring": "Monitoring panel",
      "auth": "Tizim"
    },
    "verbs": {
      "create": "Yaratish",
      "update": "Tahrirlash",
      "delete": "O'chirish",
      "view": "Ko'rish",
      "download": "Yuklab olish",
      "upload": "Fayl yuklash",
      "login": "Kirish",
      "logout": "Chiqish",
      "password": "Parolni o'zgartirish",
      "block": "Bloklash",
      "unblock": "Blokdan chiqarish",
      "ack": "Tasdiqlash",
      "other": "Amal"
    },
    "gerunds": {
      "create": "yaratish",
      "update": "tahrirlash",
      "delete": "o'chirish",
      "view": "ko'rish",
      "download": "yuklab olish",
      "upload": "fayl yuklash",
      "login": "kirish",
      "logout": "chiqish",
      "password": "parolni o'zgartirish",
      "block": "bloklash",
      "unblock": "blokdan chiqarish",
      "ack": "tasdiqlash",
      "other": "amalni bajarish"
    },
    "sections": {
      "auth": "Autentifikatsiya",
      "employees": "Xodimlar",
      "devices": "Qurilmalar",
      "device_categories": "Qurilma turkumlari",
      "device_config": "Qurilma konfiguratsiyasi",
      "device_locations": "Qurilma joylashgan o'rni",
      "device_info": "Qurilma haqida ma'lumot",
      "device_calibration": "Qurilma kolibrovkalash",
      "connectors": "Konnektorlar",
      "dashboard": "Bosh panel",
      "sections": "Bo'limlar",
      "documents": "Hujjatlar",
      "reports": "Hisobotlar",
      "charts": "Grafiklar",
      "alarm_settings": "Mezon sozlamalari",
      "system": "Tizim"
    },
    "descriptions": {
      "deniedKeyword": "ruxsat yo'q",
      "denied": "{{section}}: {{action}}ga urindi - ruxsat yo'q",
      "denied_permission_escalation": "O'zida yo'q huquqni berishga urindi - ruxsat yo'q",
      "denied_role_not_assignable": "Ruxsat etilmagan rolni berishga urindi - ruxsat yo'q",
      "auth_login": "Tizimga kirdi",
      "auth_logout": "Tizimdan chiqdi",
      "auth_password_changed": "Parolini o'zgartirdi",
      "member_created_named": "«{{name}}» xodimini qo'shdi",
      "member_updated_named": "«{{name}}» ma'lumotlarini o'zgartirdi",
      "member_password": "«{{name}}» parolini yangiladi",
      "member_moved": "«{{name}}» xodimini «{{tenant}}»ga o'tkazdi",
      "member_removed_named": "«{{name}}» xodimini o'chirdi",
      "member_blocked_named": "«{{name}}» xodimini blokladi",
      "member_unblocked_named": "«{{name}}» xodimini blokdan chiqardi",
      "document_created_named": "«{{name}}» faylini yukladi",
      "document_updated_named": "«{{name}}» hujjatini tahrirladi",
      "document_updated": "Hujjatni tahrirladi",
      "document_deleted_named": "«{{name}}» hujjatini o'chirdi",
      "document_viewed_named": "«{{name}}» hujjatini ochdi",
      "document_downloaded_named": "«{{name}}» hujjatini yuklab oldi",
      "document_folder_created_named": "«{{name}}» papkasini yaratdi",
      "document_folder_updated": "Papkani tahrirladi",
      "document_folder_deleted_named": "«{{name}}» papkasini o'chirdi",
      "dashboard_saved": "Bosh panelni saqladi",
      "section_created_named": "«{{name}}» bo'limini yaratdi",
      "section_deleted_named": "«{{name}}» bo'limini o'chirdi",
      "folder_saved": "Bo'lim chizmasini saqladi",
      "chart_created_named": "«{{name}}» grafigini yaratdi",
      "chart_updated": "Grafikni tahrirladi",
      "chart_deleted_named": "«{{name}}» grafigini o'chirdi",
      "device_created_named": "«{{name}}» qurilmasini yaratdi",
      "device_deleted_named": "«{{name}}» qurilmasini o'chirdi",
      "device_category_created_named": "«{{name}}» turkumini yaratdi",
      "device_location_created_named": "«{{name}}» joylashuvini yaratdi",
      "alarm_acknowledged": "Ogohlantirishni tasdiqladi",
      "alarm_settings_updated": "Mezon sozlamalarini o'zgartirdi",
      "alarm_rule_updated": "Ko'rsatkich chegaralarini o'zgartirdi",
      "tenant_created": "Suv omborini yaratdi",
      "tenant_updated": "Suv ombori ma'lumotlarini o'zgartirdi",
      "tenant_deleted": "Suv omborini o'chirdi",
      "organization_created": "Tashkilotni yaratdi",
      "organization_updated": "Tashkilot ma'lumotlarini o'zgartirdi",
      "organization_deleted": "Tashkilotni o'chirdi",
      "org_admin_created": "Tashkilot adminini qo'shdi",
      "org_admin_removed": "Tashkilot adminini o'chirdi"
    },
    "generic": {
      "create": "Yangi yozuv yaratdi",
      "create_named": "«{{name}}» yozuvini yaratdi",
      "update": "Ma'lumotlarni o'zgartirdi",
      "update_named": "«{{name}}» ma'lumotlarini o'zgartirdi",
      "delete": "Yozuvni o'chirdi",
      "delete_named": "«{{name}}» yozuvini o'chirdi",
      "view": "Ko'rib chiqdi",
      "view_named": "«{{name}}» ni ochdi",
      "download": "Faylni yuklab oldi",
      "download_named": "«{{name}}» ni yuklab oldi",
      "upload": "Fayl yukladi",
      "upload_named": "«{{name}}» faylini yukladi",
      "login": "Tizimga kirdi",
      "login_named": "Tizimga kirdi",
      "logout": "Tizimdan chiqdi",
      "logout_named": "Tizimdan chiqdi",
      "password": "Parolni o'zgartirdi",
      "password_named": "Parolni o'zgartirdi",
      "block": "Xodimni blokladi",
      "block_named": "«{{name}}» ni blokladi",
      "unblock": "Xodimni blokdan chiqardi",
      "unblock_named": "«{{name}}» ni blokdan chiqardi",
      "ack": "Tasdiqladi",
      "ack_named": "«{{name}}» ni tasdiqladi",
      "other": "Amal bajarildi",
      "other_named": "«{{name}}»"
    },
    "details": {
      "name": "Nomi",
      "employee": "Xodim",
      "role": "Rol",
      "fields": "O'zgartirilgan",
      "movedTo": "Yangi suv ombori",
      "version": "Versiya",
      "indicator": "Ko'rsatkich",
      "level": "Daraja",
      "request": "So'rov",
      "code": "Xato kodi",
      "browser": "Brauzer",
      "ip": "IP manzil",
      "logId": "Log ID"
    },
    "fields": {
      "fullName": "F.I.SH",
      "position": "Lavozim",
      "phone": "Telefon",
      "login": "Login",
      "isActive": "Faollik",
      "avatarFileId": "Rasm",
      "role": "Rol",
      "permissions": "Huquqlar",
      "tenantId": "Suv ombori",
      "name": "Nomi"
    },
    "csv": {
      "logId": "Log ID",
      "date": "Sana",
      "time": "Vaqt",
      "title": "Amal",
      "description": "Tavsif",
      "panel": "Panel",
      "ip": "IP manzil",
      "browser": "Brauzer",
      "outcome": "Natija",
      "ok": "Muvaffaqiyatli",
      "failed": "Xato"
    }
  }
}
